import React, { useState, useCallback } from 'react';
import { StyledButton } from "components/Buttons/DefaultButton/DefaultButton.styles";
import { SimpleModal } from '../../../../components/Modal';
import { CircularProgress } from '@material-ui/core';
import styles from '../CustomOfferDetailsPage.module.css';
import Api from 'api';
import { exitReact } from 'utils';

interface RemoveShiftButtonProps {
  job: {
    id: number;
    hygienistId?: number;
  };
}

const RemoveShiftButton: React.FC<RemoveShiftButtonProps> = ({ job }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRemoveShift = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const removeJob = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await Api.removeJob(job.id);
      setIsLoading(false);
      setIsModalOpen(false);
      exitReact('home');
    } catch (err) {
      setIsLoading(false);
      setError('Error removing shift. Please try again.');
    }
  }, [job.id]);

  const cancelMessage = 'Are you sure?';

  return (
    <>
      <StyledButton
        variant="text"
        color="error"
        size="small"
        id="continue-button"
        className={styles.removeShiftButton}
        onClick={handleRemoveShift}
      >
        Remove Shift
      </StyledButton>
      <SimpleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Remove this shift</h2>
        <div dangerouslySetInnerHTML={{ __html: cancelMessage }} />
        {isLoading && <CircularProgress />}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <div>
          <StyledButton
            variant="outlined"
            onClick={() => setIsModalOpen(false)}
          >
            No
          </StyledButton>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={removeJob}
            disabled={isLoading}
          >
            Yes
          </StyledButton>
        </div>
      </SimpleModal>
    </>
  );
};

export default RemoveShiftButton;